import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from 'shared/components/Link';
import cx from 'classnames';
import queryString from 'query-string';
import s from './Item.css';

class Item extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    params: PropTypes.shape(),
    rel: PropTypes.string,
    linkPrefix: PropTypes.string.isRequired,
    count: PropTypes.number,
    category: PropTypes.shape(),
    location: PropTypes.shape(),
    displayNone: PropTypes.bool.isRequired,
    lensEvent: PropTypes.string.isRequired,
  };

  static defaultProps = {
    count: 0,
    rel: '',
    location: null,
    category: null,
    params: null,
  };

  render() {
    const {
      title,
      location,
      linkPrefix,
      slug,
      params,
      count,
      category,
      displayNone,
      lensEvent,
      rel,
    } = this.props;

    const urlPath = [linkPrefix, slug, category && category.slug, location && location.slug]
      .filter(i => !!i)
      .join('/')
      .replace(/\/\//g, '/');

    let url = `/${urlPath}/`;

    const queryParams = params ? queryString.stringify(params) : '';
    if (queryParams) url += `?${queryParams}`;

    const linkAttr = {};
    if (rel) linkAttr.rel = rel;

    return (
      <Link
        {...linkAttr}
        to={url}
        title={title}
        className={cx(s.root, { [s.displayNone]: displayNone })}
        data-lens-event={lensEvent}
      >
        {title} <span className={s.count}>{count}</span>
      </Link>
    );
  }
}

export default withStyles(s)(Item);



// WEBPACK FOOTER //
// ./src/desktop/components/PopularMarksModels/Item/Item.js